import EventParticipationStatus from 'app/frontend/types/custom/EventParticipationStatus'
import {
  Ban,
  Check,
  Clock4,
  HelpCircle,
  PauseCircle,
  Trash2,
  X,
} from 'lucide-react'

const EventStatusIcon = ({ status }: { status: EventParticipationStatus }) => {
  const Icon = {
    absent: X,
    present: Check,
    tentative: HelpCircle,
    late: Clock4,
    standby: PauseCircle,
    missing: Ban,
    removed: Trash2,
    unknown: HelpCircle,
  }[status]

  const color = {
    absent: 'text-red-500',
    present: 'text-green-500',
    tentative: 'text-orange-500',
    late: 'text-yellow-500',
    standby: 'text-green-500',
    missing: 'text-red-500',
    removed: 'text-gray-500',
    unknown: 'text-red-500',
  }[status]

  return <Icon className={`w-4 h-4 ${color}`} />
}

export default EventStatusIcon
